<div class="modal-md order-item-modal">
  <div class="modal-header state">
    <button
      type="button"
      (click)="close()"
      class="btn btn-icon close"
      aria-label="Close"
    >
      <span class="fal fa-times" aria-hidden="true"></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="scroll-container">
      @if (showOrderSelector) {
        <div class="container order--selector">
          <app-cart-select
            [allowAdd]="true"
            (selectedOrder)="onOrderSelected($event)"
          ></app-cart-select>
        </div>
      }

      @if (order && orderItem) {
        <app-product-order-item
          [product]="orderItem.product"
          [order]="order"
          [orderItem]="orderItem"
          [delivery]="delivery"
          [paidQuantity]="quantity"
          [hideFinancials]="hideFinancials"
          viewType="list-item"
          [showBudget]="!readonly"
          [showVariations]="true"
          [showTrackingInfo]="readonly"
          [showTotals]="true"
          [modal]="true"
          [readonly]="readonly"
          (close)="close()"
          (changed)="onOrderItemChanged($event)"
          (onUpdate)="handleUpdate($event)"
        ></app-product-order-item>
      }
    </div>
  </div>
</div>
